import useApi from '../../../services/useApi'

export default function useScriptDetails(scriptId?: string) {
  const Api = useApi()

  const {data: response, isFetching} = Api.useGetQuery(
    `/storefronts/script/manager/scripts/${scriptId}`,
    {
      queryId: scriptId ? `storefront-script-details-${scriptId}` : undefined,
    },
    {enabled: !!scriptId}
  )

  return {
    script: response?.data,
    isLoading: isFetching,
  }
}
